import React, { Component } from 'react';
import {injectIntl, intlShape} from 'react-intl';
const LOCALE_PREFIX = 'DE/components/Footer/Footer';

// this Footer should be on the applypage, errorpage, and decisionpage for DE
export class DEFooter extends Component {

    static propTypes = {
        intl: intlShape.isRequired,
    };

    render() {
        const {intl} = this.props;
        return (
            <div id="de-paypal-footer" className="clearfix">
                <span className="pull-right">
                    <span id="powered-by">{intl.formatMessage({id: `${LOCALE_PREFIX}.poweredBy`})}</span>
                    <span id="cue-paypal-icon" className="pull-right" />
                </span>
            </div>
        );
    }
}

export default injectIntl(DEFooter);
